import * as React from "react";
import ReactExport from "react-export-excel-fixed-xlsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faFileExcel,
} from "@fortawesome/free-solid-svg-icons";
import { BgIconColor, LocalizationResource, PNGICONS, TaskGroup } from "../Shared/AppConstants";
import { dateFormatter } from "../../HelperMethods";
import DashboardIcons from "./DashboardIcons";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { LocalizationHelper } from "../../Localization/helpers/LocalizationHelper";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

export const ExportExcel = (data, taskGroup, isTaskTileAction = false) => {
    const today = new Date();
    const month = (today.getMonth() + 1).toString().padStart(2, '0');
    const day = today.getDate().toString().padStart(2, '0');
    const year = today.getFullYear().toString();
    const columns = []
    const fileName = data?.length > 0 && data[0].tileName.length < 31 ? data[0].tileName : "My Tasks"
    const fileNameWithDate = `${fileName}_${month}${day}${year}`;

    if (taskGroup === TaskGroup.REQUISITION) {
        columns.push(<ExcelColumn label="Requisition Number" value="reqNumber" />);
    }

    columns.push(<ExcelColumn label="Name" value="name" />);

    if (taskGroup === TaskGroup.CANDIDATE || taskGroup === TaskGroup.VENDORINVOICE) {
        columns.push(<ExcelColumn label="Vendor" value="vendor" />);
    }

    if (taskGroup === TaskGroup.TIMESHEET || taskGroup === TaskGroup.CANDIDATE || taskGroup === TaskGroup.ASSIGNMENTEXTENSION) {
        columns.push(<ExcelColumn label="Candidate Name" value="candidateName" />);
    }

    if (taskGroup === TaskGroup.REQUISITION || taskGroup === TaskGroup.CANDIDATE || taskGroup === TaskGroup.TIMESHEET || taskGroup === TaskGroup.ASSIGNMENTEXTENSION) {
        columns.push(<ExcelColumn label="Region" value="region" />);
        columns.push(<ExcelColumn label="Division" value="division" />);
        columns.push(<ExcelColumn label={LocalizationHelper.getLocalizedTitle(LocalizationResource.Location_Label, "Location")} value="location" />);
        columns.push(<ExcelColumn label="Position" value="position" />);
    }

    if (taskGroup === TaskGroup.REQUISITION) {
        columns.push(<ExcelColumn label="Req Created Date" value={(col) => col.reqCreatedDate ? dateFormatter(col.reqCreatedDate) : ""} />);
    }

    if (taskGroup === TaskGroup.CANDIDATE) {
        columns.push(<ExcelColumn label="Submitted Date" value={(col) => col.submittedDate ? dateFormatter(col.submittedDate): ""} />);
        columns.push(<ExcelColumn label="Presentation Date" value={(col) => col.presentationDate ? dateFormatter(col.presentationDate) : ""} />);
    }

    if (taskGroup === TaskGroup.ASSIGNMENTEXTENSION) {
        columns.push(<ExcelColumn label="Extension Start Date" value={(col) => col.extStartDate ? dateFormatter(col.extStartDate) : ""} />);
        columns.push(<ExcelColumn label="Extension End Date" value={(col) => col.extEndDate ? dateFormatter(col.extEndDate): ""} />);
    }

    if (taskGroup === TaskGroup.TIMESHEET) {
        columns.push(<ExcelColumn label="Timesheet Period" value="timesheetPeriod" />);
    }

    if (taskGroup === TaskGroup.VENDORINVOICE) {
        columns.push(<ExcelColumn label="Invoice Number" value="vendorInvoiceNumber" />);
        columns.push(<ExcelColumn label="Invoice Period" value="invoicePeriod" />);
    }

    if (taskGroup === TaskGroup.CLIENTINVOICE) {
        columns.push(<ExcelColumn label="Client Invoice Number" value="clientInvoiceNumber" />);
        columns.push(<ExcelColumn label="Run Date" value={(col) => col.cbiRunDate ? dateFormatter(col.cbiRunDate) : ""} />);
    }

    columns.push(
        <ExcelColumn
            label="Task Date"
            value={(col) => col.assignedDate ? dateFormatter(col.assignedDate) : ""}
        />);
    return (
        <ExcelFile
            element={
                isTaskTileAction ? 
                <button id="taskExcelBtn" hidden={true}>Download</button> :
                <span title="Export to Excel" className="mr-2 float-right text-dark shadow invoice cursor-pointer">
                    <FontAwesomeIcon icon={faFileExcel} style={{ color: "white" }} className={"faclock_size d-block"}></FontAwesomeIcon>
                </span>
            }
            filename={fileNameWithDate}

        >
            <ExcelSheet data={data} name={fileName}>
                {columns}
            </ExcelSheet>
        </ExcelFile>)

}

export const getIconWithColor = (icon) => {
    let svgList = [];
    switch(icon) {
        case PNGICONS.FLAGICON:
            svgList = [DashboardIcons.flagIcon, BgIconColor.YELLOW];
            break;
        case PNGICONS.USERICON:
            svgList = [DashboardIcons.users, BgIconColor.BLUE];
            break;
        case PNGICONS.TASKFILEICON:
            svgList = [DashboardIcons.taskFileIcon, BgIconColor.LIGHTBLUE];
            break;
        case PNGICONS.DOLLARICON:
            svgList = [DashboardIcons.dollarIcon, BgIconColor.LIGHTGREEN];
            break;
        case PNGICONS.INFOICON:
            svgList = [DashboardIcons.infoIcon, BgIconColor.GREEN];
            break;
        case PNGICONS.TICKICON:
            svgList = [DashboardIcons.tickIcon, BgIconColor.LIGHTBLUE];
            break;
        case PNGICONS.REJECTED:
            svgList = [DashboardIcons.rejected, BgIconColor.LIGHTBLUE];
            break;
        case PNGICONS.ONHOLD:
            svgList = [DashboardIcons.onHold, BgIconColor.LIGHTBLUE];
            break;
        case PNGICONS.OPEN:
            svgList = [DashboardIcons.open, BgIconColor.LIGHTBLUE];
            break;
        case PNGICONS.FILLED:
            svgList = [DashboardIcons.filled, BgIconColor.LIGHTBLUE];
            break;
        case PNGICONS.TOTALSPEND:
            svgList = [DashboardIcons.totalSpend, BgIconColor.LIGHTGREEN];
            break;
        case PNGICONS.REQFILLED:
            svgList = [DashboardIcons.filled, BgIconColor.LIGHTBLUE];
            break;
    }
    
    return svgList.length ? <i className={`icon-circle mr-2 ${svgList[1]}`}><img src={svgList[0]} /> </i>
    : null;
}

export const toolTip = (children) => {
    return (
        <Tooltip anchorElement="target" position="bottom" parentTitle={true} children={children} tooltipStyle={{ whiteSpace: 'pre-line'}} />
    )
}